// Infinite Auto-Play Carousel JavaScript - Fixed Version
(function() {
  'use strict';
  
  class InfiniteCarousel {
    constructor(element) {
      this.carousel = element;
      this.track = this.carousel.querySelector('[data-track]');
      this.slides = this.carousel.querySelectorAll('[data-slide]');
      
      if (!this.track || this.slides.length === 0) {
        console.log('Carousel elements not found or no slides');
        return;
      }
      
      this.currentTranslate = 0;
      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0; // Add this to track current position
      this.animationId;
      this.autoPlayId;
      
      this.init();
    }
    
    init() {
      this.calculateSlidesToShow();
      this.cloneSlides();
      this.setupInfiniteLoop();
      this.bindEvents();
      this.startAutoPlay();
    }
    
    calculateSlidesToShow() {
      const width = window.innerWidth;
      
      // Updated responsive breakpoints
      if (width >= 1280) {
        this.slidesToShow = 6;  // Extra large screens
      } else if (width >= 980) {
        this.slidesToShow = 4;  // Large screens (between 1280 and 980)
      } else if (width >= 768) {
        this.slidesToShow = 3;  // Tablets
      } else {
        this.slidesToShow = 1;  // Mobile
      }
      
      this.slideWidth = 100 / this.slidesToShow;
    }
    
    cloneSlides() {
      // Clone slides for infinite effect
      const originalSlides = Array.from(this.slides);
      
      // Clone slides at the beginning and end for seamless infinite loop
      const clonesNeeded = this.slidesToShow * 2;
      
      // Add clones at the end
      for (let i = 0; i < clonesNeeded; i++) {
        const clone = originalSlides[i % originalSlides.length].cloneNode(true);
        clone.classList.add('carousel-clone');
        this.track.appendChild(clone);
      }
      
      // Add clones at the beginning
      for (let i = 0; i < clonesNeeded; i++) {
        const clone = originalSlides[originalSlides.length - 1 - (i % originalSlides.length)].cloneNode(true);
        clone.classList.add('carousel-clone');
        this.track.insertBefore(clone, this.track.firstChild);
      }
      
      // Update slides collection to include clones
      this.allSlides = this.track.querySelectorAll('[data-slide]');
      this.totalSlides = this.allSlides.length;
    }
    
    setupInfiniteLoop() {
      // Position at the first real slide (after the initial clones)
      const clonesNeeded = this.slidesToShow * 2;
      this.currentIndex = clonesNeeded;
      this.currentTranslate = -this.currentIndex * this.slideWidth;
      
      // Apply initial position
      this.track.style.transform = `translateX(${this.currentTranslate}%)`;
      this.track.style.transition = 'none';
    }
    
    bindEvents() {
      // Mouse drag events
      this.track.addEventListener('mousedown', (e) => this.dragStart(e));
      this.track.addEventListener('mousemove', (e) => this.dragMove(e));
      this.track.addEventListener('mouseup', (e) => this.dragEnd(e)); // Pass event
      this.track.addEventListener('mouseleave', (e) => this.dragEnd(e)); // Pass event
      
      // Touch drag events
      this.track.addEventListener('touchstart', (e) => this.dragStart(e), { passive: false });
      this.track.addEventListener('touchmove', (e) => this.dragMove(e), { passive: false });
      this.track.addEventListener('touchend', (e) => this.dragEnd(e), { passive: false }); // Pass event
      
      // Pause auto-play on hover
      this.carousel.addEventListener('mouseenter', () => this.pauseAutoPlay());
      this.carousel.addEventListener('mouseleave', () => this.startAutoPlay());
      
      // Handle resize
      this.addResizeHandler();
      
      // Prevent default drag behavior on images
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
    }
    
    dragStart(e) {
      this.isDragging = true;
      this.startX = this.getPositionX(e);
      this.currentX = this.startX; // Initialize currentX
      this.track.style.cursor = 'grabbing';
      this.pauseAutoPlay();
      
      // Cancel any ongoing animation
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }
    
    dragMove(e) {
      if (!this.isDragging) return;
      
      e.preventDefault();
      this.currentX = this.getPositionX(e); // Update currentX
      const diffX = this.currentX - this.startX;
      const dragPercentage = (diffX / this.carousel.offsetWidth) * 100;
      
      // Update position while dragging
      const newTranslate = this.currentTranslate + dragPercentage;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${newTranslate}%)`;
    }
    
    dragEnd(e) { // Accept event parameter
      if (!this.isDragging) return;
      
      this.isDragging = false;
      this.track.style.cursor = 'grab';
      
      // Use stored currentX instead of trying to get from undefined event
      const diffX = this.currentX - this.startX;
      const threshold = 50; // Minimum drag distance to trigger slide change
      
      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          this.goToPrevious();
        } else {
          this.goToNext();
        }
      } else {
        // Snap back to current position
        this.updatePosition();
      }
      
      this.startAutoPlay();
    }
    
    getPositionX(e) {
      // Add safety check for event
      if (!e) return 0;
      return e.type.includes('mouse') ? e.clientX : (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
    }
    
    goToNext() {
      this.currentIndex++;
      this.updatePosition();
      this.checkInfiniteLoop();
    }
    
    goToPrevious() {
      this.currentIndex--;
      this.updatePosition();
      this.checkInfiniteLoop();
    }
    
    updatePosition() {
      this.currentTranslate = -this.currentIndex * this.slideWidth;
      this.track.style.transition = 'transform 0.3s ease';
      this.track.style.transform = `translateX(${this.currentTranslate}%)`;
    }
    
    checkInfiniteLoop() {
      const clonesNeeded = this.slidesToShow * 2;
      const originalSlidesCount = this.slides.length;
      
      // If we've gone past the end clones, reset to beginning
      if (this.currentIndex >= clonesNeeded + originalSlidesCount) {
        setTimeout(() => {
          this.track.style.transition = 'none';
          this.currentIndex = clonesNeeded;
          this.currentTranslate = -this.currentIndex * this.slideWidth;
          this.track.style.transform = `translateX(${this.currentTranslate}%)`;
        }, 300);
      }
      
      // If we've gone before the beginning clones, reset to end
      if (this.currentIndex < clonesNeeded) {
        setTimeout(() => {
          this.track.style.transition = 'none';
          this.currentIndex = clonesNeeded + originalSlidesCount - 1;
          this.currentTranslate = -this.currentIndex * this.slideWidth;
          this.track.style.transform = `translateX(${this.currentTranslate}%)`;
        }, 300);
      }
    }
    
    startAutoPlay() {
      this.pauseAutoPlay(); // Clear any existing interval
      
      this.autoPlayId = setInterval(() => {
        if (!this.isDragging) {
          this.goToNext();
        }
      }, 3000); // Move every 3 seconds - adjust as needed
    }
    
    pauseAutoPlay() {
      if (this.autoPlayId) {
        clearInterval(this.autoPlayId);
        this.autoPlayId = null;
      }
    }
    
    addResizeHandler() {
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const oldSlidesToShow = this.slidesToShow;
          this.calculateSlidesToShow();
          
          if (oldSlidesToShow !== this.slidesToShow) {
            // Rebuild the carousel for new layout
            this.pauseAutoPlay();
            this.rebuild();
          }
        }, 250);
      };
      
      window.addEventListener('resize', handleResize);
    }
    
    rebuild() {
      // Remove clones
      const clones = this.track.querySelectorAll('.carousel-clone');
      clones.forEach(clone => clone.remove());
      
      // Reset slides reference
      this.slides = this.carousel.querySelectorAll('[data-slide]:not(.carousel-clone)');
      
      // Rebuild
      this.cloneSlides();
      this.setupInfiniteLoop();
      this.startAutoPlay();
    }
    
    destroy() {
      this.pauseAutoPlay();
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }
  }

  // Initialize function
  function initCarousels() {
    const carousels = document.querySelectorAll('[data-carousel]');
    
    carousels.forEach((carousel, index) => {
      new InfiniteCarousel(carousel);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

})();